import React from 'react';
import { useSpring, animated } from 'react-spring';
import HeartIconFilled from '../../../../../../svg/icons/favourites-filled.svg';
import HeartIcon from '../../../../../../svg/icons/favourites.svg';
import pulsingHeartStyles from './pulsingHeart.module.pcss';

interface PulsingHeartProps {
  isOn: boolean;
}

function PulsingHeart({ isOn }: PulsingHeartProps): React.ReactElement {
  const { opacity } = useSpring({
    opacity: isOn ? 1 : 0,
    from: { display: 'none', opacity: 0, transform: 'scale(1)', top: 0, left: 0 }
  });

  const animation = {
    opacity,
    transform: opacity
      .interpolate({
        range: [0, 0.5, 1],
        output: [1, 1.3, 1]
      })
      .interpolate((x) => `scale(${x})`)
  };

  return (
    <div className={pulsingHeartStyles['pulsing-heart']}>
      <HeartIcon className={pulsingHeartStyles['pulsing-heart--empty']} />
      <animated.div style={animation} className={pulsingHeartStyles['pulsing-heart--filled']}>
        <HeartIconFilled />
      </animated.div>
    </div>
  );
}

export default PulsingHeart;
